export const SET_ROOT_INVESTMENT_ID = 'assetOwner/SET_ROOT_INVESTMENT_ID';
export const SET_SELECTED_TIME_PERIOD = 'assetOwner/SET_SELECTED_TIME_PERIOD';
export const SET_SCHEME_COST_ANALYSIS_DETAILS =
  'assetOwner/SET_SCHEME_COST_ANALYSIS_DETAILS';
export const SET_ENTITY_ROOT_INVESTMENT_IDS =
  'assetOwner/SET_ENTITY_ROOT_INVESTMENT_IDS';
export const SET_ENTITY_ROOT_INVESTMENTS =
  'assetOwner/SET_ENTITY_ROOT_INVESTMENTS';
